function curriculumNav() {
  const nav = document.querySelector('.block-curriculumloggedin');
  const title = document.querySelector('.intro h1');
  if(title && nav) {
    title.parentNode.insertBefore(nav, title.nextElementSibling);
  }
}

export { curriculumNav };

